import type { MinifiedGlobalPageSettings } from '~~/lib/ContentfulGraphqlService';
import { getShopContextSlugs } from '~/utils/shop/getShopContextSlugs';
import {
  isMagentoShopPath,
  stripTrailingSlash
} from '~/utils/shop/isMagentoShopPath';

type ShopConfig = NonNullable<MinifiedGlobalPageSettings['shopConfig']>;

function extractSlugFromPathname(pathname: string): string | undefined {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length < 2) {
    return undefined;
  }

  const routeKind = segments[1]?.toLowerCase();

  // Nuxt file-based routes — slug matching applies only to CMS `[...slug]` pages.
  if (routeKind === 'id' || routeKind === '_technical') {
    return undefined;
  }

  return segments.slice(1).join('/');
}

/**
 * Returns true when the route needs Magento `storeConfig` during SSR or navigation.
 */
export function isStoreConfigRequiredRoute(
  pathname: string,
  shopConfig: ShopConfig | null | undefined
): boolean {
  const normalizedPath = stripTrailingSlash(pathname);

  if (isMagentoShopPath(pathname)) {
    return true;
  }

  if (/\/payment(\/|$)/.test(normalizedPath)) {
    return true;
  }

  const slug = extractSlugFromPathname(normalizedPath);
  if (!slug) {
    return false;
  }

  return getShopContextSlugs(shopConfig).includes(slug);
}
